import { useEffect, useRef } from 'react';
import { useFormikContext } from 'formik';
import isEqual from 'lodash/isEqual';

const FormObserver = ({ onChange }) => {
  const formik = useFormikContext();
  const { values } = formik;
  const prevValues = useRef(values);

  useEffect(() => {
    const changedValues = Object.keys(values || {}).reduce((acc, key) => {
      if (!isEqual(values[key], prevValues.current[key])) {
        acc[key] = values[key];
      }
      return acc;
    }, {});

    if (Object.keys(changedValues).length > 0) {
      onChange(changedValues, values, prevValues.current, formik);
    }

    prevValues.current = values;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values, onChange]);

  return null;
};

export default FormObserver;
